import React from "react";
import { Row, Col } from "react-flexbox-grid";
import { useFormik } from "formik";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import { makeStyles } from "@material-ui/core/styles";
import * as Yup from "yup";

import TagSelect from "./tag-select";
import SaveButton from "./save-item";
import DeleteItem from "./delete-item";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3)
  },
  divider: {
    marginTop: theme.spacing(2)
  },
  buttons: {
    marginTop: theme.spacing(2)
  }
}));

const schema = Yup.object().shape({
  tag: Yup.string().required("Requerido"),
  value: Yup.string()
    .min(2, "Muy corto!")
    .max(50, "Muy extenso!")
    .required("Requerido")
});

const TagItem = ({ isResource = false, isNew = true, tag, value, contextType, contextId, selected }) => {
  const classes = useStyles();
  const formik = useFormik({
    validationSchema: schema,
    initialValues: {
      tag,
      value
    }
  });

  const onCompleted = () => {
    formik.resetForm();
  };

  return (
    <Row className={classes.root}>
      <Col xs={4}>
        <TagSelect value={formik.values.tag} onChange={formik.handleChange} isNew={isNew} selected={selected} />
      </Col>
      <Col xs={4}>
        <TextField
          fullWidth
          label="Valor"
          id="value"
          name="value"
          disabled={!isNew}
          value={formik.values.value}
          onChange={formik.handleChange}
        />
      </Col>
      <Col xs={4}>
        <ButtonGroup aria-label="outlined primary button group" className={classes.buttons}>
          {!isNew ?
            <DeleteItem
              isResource={isResource}
              isDisabled={isNew}
              tag={formik.values.tag}
              value={formik.values.value}
              contextType={contextType}
              contextId={contextId}
            /> :
            <SaveButton
              isDisabled={!isNew || !formik.isValid || formik.values.value === ''}
              onCompleted={onCompleted}
              tag={formik.values.tag}
              value={formik.values.value}
              contextType={contextType}
              contextId={contextId}
            />
          }
        </ButtonGroup>
      </Col>
      <Col xs={12}>
        <Divider className={classes.divider} />
      </Col>
    </Row>
  );
};

export default TagItem;



// WEBPACK FOOTER //
// ./src/components/tags-manager/tag-item/index.js